import axios from 'axios';
import API from '../config/API';

// A client's Messages: direct texts and emails, their replies, and the
// automated texts they were sent.
const headers = () => ({ 'Content-Type': 'application/json', accessToken: localStorage.getItem('accessToken') || '' });

function unwrap(res) {
    const body = (res && res.data) || {};
    if (body.statusCode === 0 || body.error) {
        const e = body.error || {};
        throw Object.assign(new Error(e.responseMessage || body.message || 'That didn’t work. Try again.'), { reason: e.reason });
    }
    return body.responseData !== undefined ? body.responseData : (body.data !== undefined ? body.data : body);
}
const rethrow = (e) => {
    const d = e && e.response && e.response.data;
    const err = d && d.error;
    throw err && err.responseMessage ? Object.assign(new Error(err.responseMessage), { reason: err.reason }) : e;
};
const url = (clientId, tail = '') => `${API.CLIENT_MESSAGES}/${encodeURIComponent(clientId)}${tail}`;

export const clientMessagesService = {
    load: (clientId) => axios.get(url(clientId), { headers: headers() }).then(unwrap, rethrow),
    send: (clientId, body) => axios.post(url(clientId), body, { headers: headers() }).then(unwrap, rethrow).then((d) => d && d.message),
    markRead: (clientId) => axios.post(url(clientId, '/read'), {}, { headers: headers() }).then(unwrap, rethrow),
};

export default clientMessagesService;
